export function performUnsubscribe(channels, channelId, handler) {
  const channel = channels.get(channelId);
  channel.unsubscribe(handler);
}